import React, { useEffect, useState } from "react";
import GaugeChart from "react-gauge-chart";
import { useSelector } from "react-redux";

const SpeedometerGraph = () => {
  const ongoingWorkentries = useSelector(
    (state) => state.operationFeature.ongoingWorkentries
  );
  const ongoingHardwareParts = useSelector(
    (state) => state.operationFeature.ongoingHardwareParts
  );

  const [filteredOngoingEntries, setFilteredOngoingEntries] = useState([]);
  const [filteredHardwareParts, setFilteredHardwareParts] = useState([]);
  console.log(
    "ProjectManager SpeedometerGraph filteredOngoingEntries",
    filteredOngoingEntries
  );
  console.log(
    "ProjectManager SpeedometerGraph filteredHardwareParts",
    filteredHardwareParts
  );

  const filterStates = [
    { filter: "All" },
    { filter: "Weekly" },
    { filter: "Monthly" },
    { filter: "Yearly" },
    { filter: "YTD" },
  ];

  useEffect(() => {
    if (ongoingWorkentries?.length) {
      setFilteredOngoingEntries(ongoingWorkentries);
    } else {
      setFilteredOngoingEntries([]);
    }
  }, [ongoingWorkentries]);

  useEffect(() => {
    if (Array.isArray(ongoingHardwareParts) && ongoingHardwareParts.length) {
      setFilteredHardwareParts(ongoingHardwareParts);
    } else {
      setFilteredHardwareParts([]);
    }
  }, [ongoingHardwareParts]);

  const handleFilterChange = (filter) => {
    const today = new Date();

    const filterByDateRange = (items, getDate) => {
      if (!Array.isArray(items) || items.length === 0) return [];

      if (filter === "All") {
        return items;
      }

      if (filter === "Weekly") {
      // Same as ManagerMyProjects - Week: Monday to Sunday (calendar week, ISO)
      const dayOfWeek = today.getDay(); // 0=Sun, 1=Mon, ..., 6=Sat
      const daysSinceMonday = dayOfWeek === 0 ? 6 : dayOfWeek - 1;
      const startOfWeek = new Date(
        today.getFullYear(),
        today.getMonth(),
        today.getDate() - daysSinceMonday,
        0,
        0,
        0,
        0
      );
      const endOfWeek = new Date(
        today.getFullYear(),
        today.getMonth(),
        today.getDate() - daysSinceMonday + 6,
        23,
        59,
        59,
        999
      );

      return items.filter((entry) => {
        const rawDate = getDate(entry);
        if (!rawDate) return false;
        const startDate = new Date(rawDate);
        return startDate >= startOfWeek && startDate <= endOfWeek;
      });
    }

    if (filter === "Monthly") {
      // Same as ManagerMyProjects - Month: 1st to last day of current calendar month
      const startOfMonth = new Date(
        today.getFullYear(),
        today.getMonth(),
        1,
        0,
        0,
        0,
        0
      );
      const endOfMonth = new Date(
        today.getFullYear(),
        today.getMonth() + 1,
        0,
        23,
        59,
        59,
        999
      );

      return items.filter((entry) => {
        const rawDate = getDate(entry);
        if (!rawDate) return false;
        const startDate = new Date(rawDate);
        return startDate >= startOfMonth && startDate <= endOfMonth;
      });
    }

    if (filter === "Yearly") {
      return items.filter((entry) => {
        const rawDate = getDate(entry);
        if (!rawDate) return false;
        const startDate = new Date(rawDate);
        return startDate.getFullYear() === today.getFullYear();
      });
    }

    if (filter === "YTD") {
      // Same logic as ProjectManager - Jan 1 to today inclusive
      const startOfYear = new Date(today.getFullYear(), 0, 1);
      return items.filter((entry) => {
        const rawDate = getDate(entry);
        if (!rawDate) return false;
        const startDate = new Date(rawDate);
        return startDate >= startOfYear && startDate <= today;
      });
    }

    return items;
    };

    // For non‑hardware services, keep existing behaviour (work entries by startdate)
    const filteredEntries = filterByDateRange(
      ongoingWorkentries || [],
      (entry) => entry?.startdate
    );
    setFilteredOngoingEntries(filteredEntries ?? []);

    // For hardware (part list), filter using part startdate
    const filteredParts = filterByDateRange(
      ongoingHardwareParts || [],
      (part) => part?.startdate
    );
    setFilteredHardwareParts(filteredParts ?? []);
  };

  const [completeTaskPercentage, setcompleteTaskPercentage] = useState(0);

  useEffect(() => {
    // 1️⃣ Hardware productivity for hardware project manager / operations
    //    Use filteredHardwareParts so date filters (Weekly / Monthly / YTD) apply
    if (Array.isArray(filteredHardwareParts) && filteredHardwareParts.length > 0) {
      const totalAssignedQuantity = filteredHardwareParts.reduce((sum, part) => {
        const qty = Number(String(part?.quantity ?? 0).toString().replace(/,/g, ""));
        return sum + (isNaN(qty) ? 0 : qty);
      }, 0);

      const completeQuantity = filteredHardwareParts.reduce((sum, part) => {
        if (!part?.isTaskComplete) return sum;
        const qty = Number(String(part?.quantity ?? 0).toString().replace(/,/g, ""));
        return sum + (isNaN(qty) ? 0 : qty);
      }, 0);

      const percentage =
        totalAssignedQuantity > 0
          ? (completeQuantity / totalAssignedQuantity) * 100
          : 0;

      const finalPercentage = isNaN(percentage)
        ? 0
        : parseFloat(percentage.toFixed(2));

      setcompleteTaskPercentage(finalPercentage);
      return;
    }

    // 2️⃣ Fallback: existing hours-based productivity (non‑hardware users)
    const completedCount = filteredOngoingEntries.filter(
      (task) => task.isTaskComplete === true
    ).length;

    const totalCount = filteredOngoingEntries.length;
    const totalHoursAssigned = filteredOngoingEntries.reduce(
      (sum, task) => sum + (task.hoursassigned || 0),
      0
    );
    const totalHoursSpent = filteredOngoingEntries.reduce(
      (sum, task) => sum + (task.hoursspent || 0),
      0
    );

    const completionPercentageHours =
      totalCount === 0 || totalHoursAssigned === 0 || totalHoursSpent === 0
        ? 0
        : (
            (completedCount / totalCount) *
            (totalHoursAssigned / totalHoursSpent) *
            100
          ).toFixed(2);
    const finalPercentage = isNaN(parseFloat(completionPercentageHours))
      ? 0
      : parseFloat(completionPercentageHours);

    setcompleteTaskPercentage(finalPercentage);
  }, [filteredOngoingEntries, filteredHardwareParts]);

  const Percentage =
    isNaN(completeTaskPercentage) || completeTaskPercentage === ""
      ? 0
      : completeTaskPercentage > 100
      ? 100
      : completeTaskPercentage;

  const [adjustedPercentage, setAdjustedPercentage] = useState(null);
  const [showChart, setShowChart] = useState(false);

  useEffect(() => {
    if (Percentage !== undefined && Percentage !== null && !isNaN(Percentage)) {
      const normalized = Math.min(1, Percentage / 100);
      setAdjustedPercentage(normalized);
    } else {
      setAdjustedPercentage(0);
    }
  }, [Percentage]);

  useEffect(() => {
    const timer = setTimeout(() => {
      setShowChart(true);
    }, 1000); // You can increase to 1000ms if needed
    return () => clearTimeout(timer);
  }, []);

  return (
    <div className="bg-white rounded-md h-full flex flex-col">
      {/* Header */}
      <div className="flex-none h-[10%] flex items-center py-4 px-2 justify-between">
        <div>
          <h3 className="font-semibold">Productivity</h3>
        </div>

        <div>
          <div className="relative flex rounded-xl items-center">
            <select
              className="relative cursor-pointer border w-full text-xs border-gray-400 rounded-md p-1 outline-none bg-white"
              onChange={(e) => handleFilterChange(e.target.value)}
            >
              <option hidden value="">
                Select Option
              </option>
              {filterStates.map((group) => (
                <option key={group.filter} value={group.filter}>
                  {group.filter}
                </option>
              ))}
            </select>
          </div>
        </div>
      </div>
      <hr />
      <hr />
      <div className="relative w-full h-[88%] flex flex-col justify-center items-center align-middle border-black-400">
        <div className="relative td:w-80 cp:w-80 h-24 lg:h-20 cp:h-24 td:h-24">
          {showChart && adjustedPercentage !== null && (
            <div style={{ transform: "translateY(-40px)" }}>
              <GaugeChart
                id="gauge-chart"
                nrOfLevels={10}
                percent={adjustedPercentage}
                textColor="#000"
                hideText={true}
                arcsLength={[0.5, 0.25, 0.25]}
                colors={["red", "#ff7720", "green"]}
                arcPadding={0}
                cornerRadius={0}
                animate={false}
              />
            </div>
          )}
        </div>

        <div className="w-[70%] lg:w-[75%] xl:w-[70%] flex justify-between text-black text-sm sm:text-base font-semibold py-2">
          <div className="w-[60px] text-left text-xs">0%</div>
          <div className="text-center flex-1">
            <div className="text-xs">Productivity </div>
            <div className="text-xs">({isNaN(Percentage) ? 0 : Percentage}%)</div>
          </div>
          <div className="w-[60px] text-right text-xs">100%</div>
        </div>
      </div>
    </div>
  );
};

export default SpeedometerGraph;
